export { QuantityStepper, type QuantityStepperProps } from './quantity-stepper';
